import React from 'react';
import { Group } from '@mui/icons-material';
import { gql } from '../__generated__';
import { NumberWidget } from './NumberWidget';

const query = gql(`
  query PendingMarkdowns {
    number: pendingMarkdowns
  }
`);

export function PendingMarkdowns() {
  return <NumberWidget heading="Tilganger under oppsigelse" query={query} icon={<Group fontSize="large" />}></NumberWidget>;
}
